import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getSettings() {
        try{            
            const response = await axios.get(`AttendanceReminder/settings`, {
                headers: {
                    'page_key': pageKeys.automated_reminders
                }
            })                             
            return response
        }catch (error){
            console.log('AttendanceReminder api getSettings error')
            throw error
        }
    },
    async updateSettings(data) {
        try{            
            const response = await axios.post(`AttendanceReminder/settings`, data,
            {
                headers: {
                    'page_key': pageKeys.automated_reminders
                }
            })             
            return response
        }catch (error){
            console.log('AttendanceReminder api updateSettings error')
            throw error
        }
    },
    async getReminders(userIdStr, transDate) {
        try{            
            const response = await axios.get(`AttendanceReminder/reminders/${userIdStr}/${transDate}`, {
                headers: {
                    'page_key': pageKeys.automated_reminders
                }
            })                             
            return response
        }catch (error){
            console.log('AttendanceReminder api getReminders error')
            throw error
        }
    },
}